import axios, { AxiosInstance } from "axios";

const thaAxios: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_THA_API_URL,
});

thaAxios.interceptors.request.use(
  (req) => {
    req.headers["NowtelAuth"] = "2883E92C-4893-48E1-B3CE-98F2AF04DE3C";

    return req;
  },
  (error) => Promise.reject(error)
);

thaAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => Promise.reject(error)
);

export default thaAxios;
